import React, { useState } from "react";
import { freelancingProjects } from "../../../Data/Data";
import Project from "../../utils/Project";
import Pagination from "../../utils/Pagination";

const FreelancingProjects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const totalPages = Math.ceil(freelancingProjects.length / itemsPerPage);

  const newData = freelancingProjects.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <>
      <h2 className="text-lg py-[1.3rem]">Freelancing Projects</h2>
      <section className="p-4 bg-box">
        <div className="space-y-4">
          {newData.map((item) => (
            <Project item={item} key={item.id} />
          ))}
        </div>
        {totalPages > currentPage && (
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </section>
    </>
  );
};

export default FreelancingProjects;
